import { render, staticRenderFns } from "./ProductSpecsElementForm.vue?vue&type=template&id=21d55b1d"
import script from "./ProductSpecsElementForm.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports